import {Routes} from '@angular/router';
import {authGuard} from './features/auth/guards/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/routes/auth.routes').then(r => r.authRoutes),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./features/dashboard/routes/dashboard.routes').then(r => r.dashboardRoutes),
    canMatch: [authGuard]
  }
];
